import { RootState } from "../../../../store";
import { widgetSetupSelector } from "../widgetSetupSelector";
import { CostBreakdownWidgetSetupType } from "../../../utils/types/setups/costBreakdownSetupType";

export const costBreakdownWidgetSetupSelector = (
  state: RootState,
): CostBreakdownWidgetSetupType | undefined => {
  if (!widgetSetupSelector(state)) {
    return;
  }
  return widgetSetupSelector(state) as CostBreakdownWidgetSetupType;
};
